
  import {Component, Prop, Vue} from 'vue-property-decorator';

  import {list} from '@/api/notice';

  @Component({})
  export default class Notice extends Vue {
    @Prop({default: () => true}) private isTop!: boolean;
    private items = [];

    private async mounted() {
      await this.getList();
    }

    private async getList() {
      let result = await list();
      if (result.items.length > 0) {
        this.items = result.items;
        this.close(true);
      }
    }

    private close(v: boolean) {
      this.$emit('getIsNotice', v);
    }
  };
